import { QueryParamConfig, ArrayParam } from 'use-query-params';

type ArrayEncodedValue = (string | null)[] | null | undefined;
export const StringArrayParam: QueryParamConfig<string[], string[]> = {
  encode: (value) => (ArrayParam.encode(value) as ArrayEncodedValue) || [],
  decode: (value) =>
    (ArrayParam.decode(value) || []).filter((item): item is string => item !== null),
};
